/* eslint-disable */
import { Button, Chip, Grid, IconButton, Snackbar, Typography } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import CloseIcon from '@material-ui/icons/Close';
import ErrorIcon from '@material-ui/icons/Error';
import cn from 'classnames';
import moment from 'moment';
import React, { useContext, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, compose } from 'redux';
import { ORDER_ALREADY_PLACED_ON_THIS_DEVICE } from '../../Constants/Order/Order.constants';
import * as themeConstants from '../../Constants/Theme/Theme.constants';
import BannersContext from '../../Contexts/Banners/Banners.context';
import withServices from '../../Contexts/Services/WithServices.context';
import { createLogoutPageLink } from '../../Pages/Logout/Logout.page.route';
import { createOrderPageLink } from '../../Pages/Order/Order.page.route';
import { createOrdersPageLink } from '../../Pages/Orders/Orders.page.route';
import docketsActionCreators from '../../State/Store/Dockets/Dockets.actions';
import filtersActionCreators from '../../State/Store/Filters/Filters.actions';
import getFiltersSelectedAccount from '../../State/Store/Filters/Selectors/FiltersSelectedAccount.selector';
import uiActionCreators from '../../State/Store/UI/UI.actions';
import {
  UI_ORDER_PLACED_MODAL_GO_TO_ORDER,
  UI_ORDER_PLACED_MODAL_GO_TO_ORDERS_LIST,
  UI_ORDER_PLACED_MODAL_PLACE_ANOTHER_ORDER,
  UI_ORDER_TIPS_BANNER_DISMISS,
  UI_ORDER_TIPS_BANNER_VIEW,
  UI_PLACE_ORDER_CREATE_ORDER,
  UI_PLACE_ORDER_LEAVE_PAGE_NO,
  UI_PLACE_ORDER_LEAVE_PAGE_YES,
  UI_PLACE_ORDER_MODAL_CANCEL_ORDER,
  UI_PLACE_ORDER_MODAL_OPEN_TERMS,
  UI_PLACE_ORDER_MODAL_PLACE_ORDER,
  UI_PLACE_ORDER_MODAL_SWITCH_TERMS,
  UI_PLACE_ORDER_PAGE_TIPS_CLOSE,
  UI_PLACE_ORDER_PAGE_TIPS_OPEN,
  UI_PLACE_ORDER_REFRESH_PAGE_CONFIRM,
} from '../../State/Store/UI/UI.types';
import userProfileSelector from '../../State/Store/UserProfile/Selectors/UserProfileCurrent.selector';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import BannerNotificationComponent from '../BannerNotification/BannerNotification.component';
import HereMaps from '../HereMaps/HereMaps.component';
import Icons from '../Icons/Icons.component';
import Modal from '../Modal/Modal.component';
import Spinner from '../Spinner/Spinner.component';
import AccountProjectSelector from './AccountProjectSelector.component';
import DateTimeSelector from './DateTimeSelector.component';
import DriverInstructions from './DriverInstructions.component';
import LotNumberSelector from './LotNumberSelector.component';
import OrderStatusSelector from './OrderStatusSelector.component';
import PlaceOrderPropTypes from './PlaceOrder.component.props';
import placeOrderStyles from './PlaceOrder.component.styles';
import PlusLoad from './PlusLoad.component';
import PourMethod from './PourMethod.component';
import ProductSelector from './ProductSelector.component';
import PurchaseOrderSelector from './PurchaseOrderSelector.component';
import QuantitySelector from './QuantitySelector.component';
import SiteContact from './SiteContact.component';
import SlumpSelector from './SlumpSelector.component';
import TestResults from './TestResults.component';
import TruckSizeSelector from './TruckSizeSelector.component';
import TruckSpacingSelector from './TruckSpacingSelector.component';
import { MFSDR } from 'Constants/MouseFlow/SensitiveDataReplacer';
import PlaceOrderErrorMessage from '../PlaceOrder/PlaceOrderErrorMessage.component';

let unblock = null;

/**
 * PlaceOrder
 * @param {any} props The props
 * @returns {React.Component} The component
 */
const PlaceOrder = ({ actions, classes, history, services, userInfo, currentAccountGlobal }) => {
  const [showConfirm, setShowConfirm] = useState(false);
  const [formChanged, setFormChanged] = useState(false);
  const [accountProject, setAccountProject] = useState({ isValid: false });
  const [dateTime, setDateTime] = useState({ isValid: false });
  const [location, setLocation] = useState({ isValid: false });
  const [product, setProduct] = useState({ isValid: false });
  const [quantity, setQuantity] = useState({ isValid: false });
  const [showReview, setShowReview] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [agreedTerms, setAgreedTerms] = useState(false);
  const [orderStatus, setOrderStatus] = useState({ isValid: false });
  const [placeOrderError, setPlaceOrderError] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [pourMethod, setPourMethod] = useState({ isValid: false });
  const [slump, setSlump] = useState({ isValid: true });
  const [driverInstructions, setDriverInstructions] = useState({ isValid: false });
  const [isDriverInstructionsRequired, setIsDriverInstructionsRequired] = useState(false);
  const [truckSize, setTruckSize] = useState({ isValid: true });
  const [truckSpacing, setTruckSpacing] = useState({ isValid: false });
  const [purchaseOrder, setPurchaseOrder] = useState({ isValid: false });
  const [testResults, setTestResults] = useState({ isValid: true });
  const [formRefreshKey, setFormRefreshKey] = useState(Date.now());
  const [plusLoad, setPlusLoad] = useState({ isValid: true });
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [siteContact, setSiteContact] = useState({ isValid: true });
  const [lotNumber, setLotNumber] = useState({ isValid: true });
  const [alreadyPlacedOnThisDevice, setAlreadyPlacedOnThisDevice] = useState(true);
  const bannerContext = useContext(BannersContext);
  const [showFormErrors, setShowFormErrors] = useState(false);
  const [stateCode, setStateCode] = useState('');

  useEffect(() => {
    if (unblock) {
      unblock();
    }
    setTimeout(async () => {
      if (!(await services.storageService.getItem(ORDER_ALREADY_PLACED_ON_THIS_DEVICE))) {
        // banner not acted upon on this device yet so show banner
        setAlreadyPlacedOnThisDevice(false);
        // pause notifications coming from API as we need todisplay tips banner ontop of everything else
        // bannerContext.setPauseBannerNotifications(true);
      }
    }, 2000);
    return () => {
      // bannerContext.setPauseBannerNotifications(false);
    };
  }, []);

  useEffect(() => {
    if (unblock) {
      unblock();
    }

    if (formChanged) {
      // as we want to simply overload existing listener
      window.onbeforeunload = () => {
        actions.uiTriggered({
          payload: {
            data: {
              name: `placeOrderRefreshPageConfirm`,
            },
          },
          type: UI_PLACE_ORDER_REFRESH_PAGE_CONFIRM,
        });
        return `Are you sure?`;
      };
    }

    unblock = history.block((targetLocation) => {
      // take your action here
      // if logout is clicked always leave, this won't give user a chance to accidentally leave screen logged in without realising that logout didn't happen
      if (targetLocation.pathname === createLogoutPageLink()) {
        return true;
      }
      if (!formChanged) {
        setShowConfirm(false);
        return true;
      }
      setShowConfirm(targetLocation);
      return false;
    });
    return () => {
      unblock();
      window.onbeforeunload = () => {};
    };
  }, [formChanged]);

  /**
   * Ignores navigation and hides modal
   * @returns {void} void
   * @memberof PlaceOrder
   */
  const ignoreNavigation = () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `placeOrderLeavePageNo`,
        },
      },
      type: UI_PLACE_ORDER_LEAVE_PAGE_NO,
    });

    setShowConfirm(false);
    return;
  };

  /**
   * Navigates to specific url
   * @returns {Object} component
   * @memberof PlaceOrder
   */
  const navigateAway = () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `placeOrderLeavePageYes`,
        },
      },
      type: UI_PLACE_ORDER_LEAVE_PAGE_YES,
    });

    unblock();
    history.push(showConfirm.pathname);
    return;
  };

  /**
   * Creates order
   * @returns {Object} component
   * @memberof PlaceOrder
   */
  const createOrderHandler = () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `placeOrderCreateOrder`,
        },
      },
      type: UI_PLACE_ORDER_CREATE_ORDER,
    });
    if (!isAllValid()) {
      setShowFormErrors(true);
    } else {
      setShowFormErrors(false);
      setShowReview(true);
    }
    return;
  };

  /**
   * Checks if all the form for placing order is valid and good for submitting
   * @returns {Object} react component
   * @memberof PlaceOrder
   */
  const isAllValid = () => {
    if (
      accountProject &&
      dateTime &&
      location &&
      product &&
      accountProject.isValid &&
      dateTime.isValid &&
      location.isValid &&
      product.isValid &&
      pourMethod.isValid &&
      truckSpacing.isValid &&
      quantity.isValid &&
      orderStatus.isValid &&
      slump.isValid &&
      purchaseOrder.isValid &&
      siteContact.isValid &&
      testResults.isValid &&
      lotNumber.isValid &&
      driverInstructions.isValid
    ) {
      return true;
    }
    return false;
  };

  /**
   * Handles change in quantity
   * @param {Object} quantity quantity entered
   * @returns {void} void
   * @memberof PlaceOrder
   */
  const quantitytHandler = (quantity) => {
    setQuantity(quantity);
    return;
  };

  /**
   * Handles change in account selector
   * @param {Object} selectedAccountProject selected details
   * @returns {void} void
   * @memberof PlaceOrder
   */
  const accountProjectHandler = (selectedAccountProject) => {
    if (!selectedAccountProject.isFirstChange) {
      setFormChanged(true);
    }
    setAccountProject(selectedAccountProject);
    return;
  };

  /**
   * Handles change in date/time selector
   * @param {Object} selectedDateTime selected details
   * @returns {void} void
   * @memberof PlaceOrder
   */
  const dateTimeHandler = (selectedDateTime) => {
    if (!selectedDateTime.isFirstChange) {
      setFormChanged(true);
    }
    setDateTime({
      selectedDateTime: selectedDateTime.selectedDateTime, // DateTimeSelector needs this internally so we need to keep this
      isValid: selectedDateTime.isValid,
      timeZoneOffset: -new Date().getTimezoneOffset(),
      details: selectedDateTime.details,
    });
    return;
  };

  /**
   * Handles change in date/time selector
   * @param {Object} confirmed selected details
   * @returns {void} void
   * @memberof PlaceOrder
   */
  const statusOrderHandler = (confirmed) => {
    setOrderStatus(confirmed);
    return;
  };

  /**
   * Handles change in address location
   * @param {Object} selectedLocation selected location
   * @returns {void} void
   * @memberof PlaceOrder
   */
  const locationHandler = (selectedLocation) => {
    setFormChanged(true);
    setLocation(selectedLocation);
    const stateCode = (selectedLocation?.selectedLocation?.details?.stateCode || '').replace(/<b>|<\/b>/g, '').toUpperCase();
    setStateCode(stateCode);
    return;
  };

  /**
   * Handles slump selection
   * @param {Object} selectedSlump selected product
   * @returns {void} void
   * @memberof PlaceOrder
   */
  const slumpHandler = (selectedSlump) => {
    setSlump(selectedSlump);
    return;
  };

  /**
   * Handles change in driver instructions
   * @param {Object} selectedDriverInstructions selected location
   * @returns {void} void
   * @memberof PlaceOrder
   */
  const driverInstructionsHandler = (selectedDriverInstructions) => {
    setFormChanged(true);
    setDriverInstructions(selectedDriverInstructions);
    return;
  };

  /**
   * Handles change in lot number
   * @param {Object} selectedLotNumber selected location
   * @returns {void} void
   * @memberof PlaceOrder
   */
  const lotNumberHandler = (selectedLotNumber) => {
    setFormChanged(true);
    setLotNumber(selectedLotNumber);
    return;
  };

  /**
   * Handles product selection
   * @param {Object} selectedProduct selected product
   * @returns {void} void
   * @memberof PlaceOrder
   */
  const productHandler = (selectedProduct) => {
    setFormChanged(true);
    setProduct({ ...selectedProduct, slump: selectedProduct.selectedProduct ? selectedProduct.selectedProduct.slump : 0 });
    setSlump({ slump: selectedProduct.selectedProduct ? selectedProduct.selectedProduct.slump : null, isValid: true });
    return;
  };

  /**
   * Handles pour method selection
   * @param {Object} selectedPourMethod selected product
   * @returns {void} void
   * @memberof PlaceOrder
   */
  const pourMethodHandler = (selectedPourMethod) => {
    setFormChanged(true);
    setPourMethod(selectedPourMethod);
    return;
  };

  /**
   * Handles truck size selection
   * @param {Object} selectedTruckSize selected product
   * @returns {void} void
   * @memberof PlaceOrder
   */
  const truckSizeHandler = (selectedTruckSize) => {
    setTruckSize(selectedTruckSize);
    return;
  };

  /**
   * Handles purchase order change
   * @param {Object} selectedPurchaseOrder selected product
   * @returns {void} void
   * @memberof PlaceOrder
   */
  const purchaseOrderHandler = (selectedPurchaseOrder) => {
    setPurchaseOrder(selectedPurchaseOrder);
    return;
  };

  /**
   * Handles test results change
   * @param {Object} selectedTestResults selected product
   * @returns {void} void
   * @memberof PlaceOrder
   */
  const testResultsHandler = (selectedTestResults) => {
    setTestResults(selectedTestResults);
    return;
  };

  /**
   * Handles purchase order change
   * @param {Object} selectedPlusLoad selected product
   * @returns {void} void
   * @memberof PlaceOrder
   */
  const plusLoadHandler = (selectedPlusLoad) => {
    setPlusLoad({ isValid: true, selectedPlusLoad: selectedPlusLoad.isOn });
    return;
  };

  /**
   * Renders account/project selector
   * @returns {Object} react component
   * @memberof PlaceOrder
   */
  const renderAccountProjectSelector = () => {
    return <AccountProjectSelector mandatoryFieldError={showFormErrors && !accountProject.isValid} onValidChange={accountProjectHandler} />;
  };

  /**
   * Cancels create order modal
   * @returns {void} void
   * @memberof PlaceOrder
   */
  const cancelOrderModal = () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `placeOrderModalCancelOrder`,
        },
      },
      type: UI_PLACE_ORDER_MODAL_CANCEL_ORDER,
    });
    setShowReview(false);
    return;
  };

  /**
   * Reset form so another order can be placed
   * @returns {void} void
   * @memberof PlaceOrder
   */
  const placeAnotherOrder = () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `placeOrderPlacedModalPlaceAnotherOrder`,
        },
      },
      type: UI_ORDER_PLACED_MODAL_PLACE_ANOTHER_ORDER,
    });
    // reset all
    setShowSuccess(false);
    setShowConfirm(false);
    setFormChanged(false);
    setAccountProject({ isValid: false });
    setDateTime({ isValid: false });
    setLocation({ isValid: false });
    setProduct({ isValid: false });
    setQuantity({ isValid: false });
    setShowReview(false);
    setAgreedTerms(false);
    setOrderStatus({ isValid: false });
    setPlaceOrderError(false);
    setIsSaving(false);
    setPourMethod({ isValid: false });
    setSlump({ isValid: false });
    setDriverInstructions({ isValid: true });
    setIsDriverInstructionsRequired(false);
    setTruckSize({ isValid: false });
    setTruckSpacing({ isValid: false });
    setPurchaseOrder({ isValid: false, selectedPurchaseOrder: '' });
    setFormRefreshKey(Date.now());
    setTestResults({ isValid: true });
    setLotNumber({ isValid: true, selectedLotNumber: '' });
    setPlusLoad({ isValid: true, selectedPlusLoad: false });
    return;
  };

  /**
   * Places order and closes modal
   * @returns {void} void
   * @memberof PlaceOrder
   */
  const placeOrderModal = async () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `placeOrderModalPlaceOrder`,
        },
      },
      type: UI_PLACE_ORDER_MODAL_PLACE_ORDER,
    });

    const latlng = {
       latitude: location.selectedLocation.coords.lat,
       longitude:location.selectedLocation.coords.lng
    };

    const payload = {
      accountProject: { account: accountProject.account, project: accountProject.project },
      dateTime: {
        offset: dateTime.timeZoneOffset,
        details: dateTime.details,
      },
      location: { address: location.selectedLocation.address, coords: latlng , details: location.selectedLocation.details },
      product: product.selectedProduct,
      quantity: quantity.quantity,
      orderStatusConfirmed: orderStatus.confirmed,
      pourMethod: pourMethod.selectedPourMethod.code,
      truckSpacing: truckSpacing.selectedTruckSpacing,
      slump: slump.slump,
      plusLoad: !!plusLoad.selectedPlusLoad,
    };

    if (truckSize.selectedTruckSize && truckSize.selectedTruckSize !== `any`) {
      payload.truckSize = truckSize.selectedTruckSize;
    }

    if (purchaseOrder.selectedPurchaseOrder) {
      payload.purchaseOrder = purchaseOrder.selectedPurchaseOrder.trim();
    }

    if (driverInstructions.selectedDriverInstructions) {
      payload.driverInstructions = driverInstructions.selectedDriverInstructions.trim();
    }

    if (siteContact.selectedName) {
      payload.siteContactName = siteContact.selectedName.trim();
    }

    if (siteContact.selectedPhoneNumber) {
      payload.siteContactPhoneNumber = siteContact.selectedPhoneNumber.trim();
    }

    if (testResults.selectedRequirements && testResults.selectedRequirements.value !== `NO_TESTING_REQUIRED`) {
      payload.testRequirements = testResults.selectedRequirements.value;
      payload.testFrequency = testResults.selectedFrequency.value;
      if (testResults.selectedNotes) {
        payload.selectedNotes = testResults.selectedNotes;
      }
    } else {
      payload.testRequirements = `NO_TESTING_REQUIRED`;
    }

    if (lotNumber.selectedLotNumber) {
      payload.lotNumber = lotNumber.selectedLotNumber.trim();
    }

    try {
      setIsSaving(true);
      const result = await services.orderService.placeOrder(payload);
      setShowReview(false);
      setIsSaving(false);
      setPlaceOrderError(false);
      setFormChanged(false);
      setAlreadyPlacedOnThisDevice(true);
      // bannerContext.setPauseBannerNotifications(false);
      setShowSuccess(result.response);
    } catch (ex) {
      setIsSaving(false);
      setPlaceOrderError(true);
      setShowSuccess(false);
    }

    return;
  };

  /**
   * Handles change in truckSpacing
   * @param {Object} spacing truck spacing entered
   * @returns {void} void
   * @memberof PlaceOrder
   */
  const truckSpacingHandler = (spacing) => {
    setTruckSpacing(spacing);
    return;
  };

  /**
   * Handles change in truckSpacing
   * @param {Object} spacing truck spacing entered
   * @returns {void} void
   * @memberof PlaceOrder
   */
  const siteContactHandler = (updatedSiteContact) => {
    setSiteContact({
      isValid: updatedSiteContact.isValid,
      selectedPhoneNumber: updatedSiteContact.selectedPhoneNumber,
      selectedName: updatedSiteContact.selectedName,
    });
    return;
  };

  /**
   * Renders date/time selector
   * @returns {Object} react component
   * @memberof PlaceOrder
   */
  const renderDateTimeSelector = () => {
    return <DateTimeSelector onChange={dateTimeHandler} defaultDateTime={dateTime} tradingRegion={accountProject.account.tradingRegion} />;
  };

  /**
   * Switches T&Cs
   * @returns {void} void
   * @memberof PlaceOrder
   */
  const switchTCs = () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `placeOrderModalSwitchTerms`,
        },
      },
      type: UI_PLACE_ORDER_MODAL_SWITCH_TERMS,
    });
    setAgreedTerms(!agreedTerms);
    return;
  };

  /**
   * Shows page tips
   * @returns {void} void
   * @memberof PlaceOrder
   */
  const showTips = () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `placeOrderPageTipsOpen`,
        },
      },
      type: UI_PLACE_ORDER_PAGE_TIPS_OPEN,
    });
    setDrawerOpen(true);
    return;
  };

  /**
   * Hides page tips
   * @returns {void} void
   * @memberof PlaceOrder
   */
  const hideTips = () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `placeOrderPageTipsClose`,
        },
      },
      type: UI_PLACE_ORDER_PAGE_TIPS_CLOSE,
    });
    setDrawerOpen(false);
    return;
  };

  /**
   * Report open T&Cs
   * @returns {void} void
   * @memberof PlaceOrder
   */
  const reportOpenTCs = () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `placeOrderModalOpenTerms`,
        },
      },
      type: UI_PLACE_ORDER_MODAL_OPEN_TERMS,
    });
    setAgreedTerms(!agreedTerms);
    return;
  };

  /**
   * Redirects user to orders list to specific order just placed
   * @returns {void} void
   * @memberof PlaceOrder
   */
  const goToThisOrdersList = () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `placeOrderPlacedModalGoToOrder`,
        },
      },
      type: UI_ORDER_PLACED_MODAL_GO_TO_ORDER,
    });
    // this is to redirect to orders list when its necessary. This should also scroll to specified order when the list is loaded. It was commented out as requirements kept changing
    // history.push(`${createOrdersPageLink()}#${moment(dateTime.selectedDateTime).format(`YYYYMMDD`)}-${showSuccess.orderId}-2`);
    history.push(`${createOrderPageLink({ orderId: `${moment(dateTime.selectedDateTime).format(`YYYYMMDD`)}-${showSuccess.orderId}-2` })}`);
    return;
  };

  /**
   * Redirects user to orders list
   * @returns {void} void
   * @memberof PlaceOrder
   */
  const goToOrdersList = () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `placeOrderPlacedModalGoToOrdersList`,
        },
      },
      type: UI_ORDER_PLACED_MODAL_GO_TO_ORDERS_LIST,
    });
    history.push(createOrdersPageLink());
    return;
  };

  /**
   * Dismiss tips banner handler
   * @returns {void} void
   * @memberof PlaceOrder
   */
  const dismissBannerHandler = async () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `orderTipsBannerDismiss`,
        },
      },
      type: UI_ORDER_TIPS_BANNER_DISMISS,
    });

    setAlreadyPlacedOnThisDevice(true);
    await services.storageService.setItem(ORDER_ALREADY_PLACED_ON_THIS_DEVICE, true);
    // and unpause other notifications that might need to be displayed
    // bannerContext.setPauseBannerNotifications(false);
    return;
  };

  /**
   * Address street number changed handler
   * @returns {string} hasStreetNumber
   * @memberof PlaceOrder
   */
  const addressStreetNumberChangeHandler = (hasStreetNumber) => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `orderTipsBannerDismiss`,
        },
      },
      type: UI_ORDER_TIPS_BANNER_DISMISS,
    });

    setIsDriverInstructionsRequired(!hasStreetNumber);
    return;
  };

  /**
   * View tips banner handler
   * @returns {void} void
   * @memberof PlaceOrder
   */
  const viewTipsBannerHandler = async () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `orderTipsBannerView`,
        },
      },
      type: UI_ORDER_TIPS_BANNER_VIEW,
    });
    setDrawerOpen(true);
    setAlreadyPlacedOnThisDevice(true);
    await services.storageService.setItem(ORDER_ALREADY_PLACED_ON_THIS_DEVICE, true);
    // and unpause other notifications that might need to be displayed
    // bannerContext.setPauseBannerNotifications(false);
    return;
  };

  /**
   * Renders review content
   * @returns {Object} react component
   * @memberof PlaceOrder
   */
  const renderReview = () => {
    if (!showReview) {
      return null;
    }

    let streetLine = ``;
    let stateLine = ``;
    if (location.selectedLocation.details) {
      if (location.selectedLocation.details.houseNumber) {
        streetLine = location.selectedLocation.details.houseNumber.replace(/<b>|<\/b>/g, ``);
      }
      if (location.selectedLocation.details.street) {
        streetLine += ` ${location.selectedLocation.details.street.replace(/<b>|<\/b>/g, ``)}`;
      }
      if (location.selectedLocation.details.district) {
        stateLine += ` ${location.selectedLocation.details.district.replace(/<b>|<\/b>/g, ``)}`;
      }
      if (location.selectedLocation.details.city && !location.selectedLocation.details.district) {
        stateLine += ` ${location.selectedLocation.details.city.replace(/<b>|<\/b>/g, ``)}`;
      }
      if (location.selectedLocation.details.stateCode) {
        stateLine += ` ${location.selectedLocation.details.stateCode.replace(/<b>|<\/b>/g, ``)}`;
      }
      if (location.selectedLocation.details.postalCode) {
        stateLine += ` ${location.selectedLocation.details.postalCode.replace(/<b>|<\/b>/g, ``)}`;
      }
    }

    return (
      <React.Fragment>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="body2" className={cn(classes.marginBottom2unit)}>
              Please review the details of your order below
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={6} className={classes.lightText}>
            <Typography variant="overline">Account</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="overline" className={classes.fontWeight500} data-mf-replace-inner={MFSDR}>
              {accountProject.account.name}
            </Typography>
          </Grid>
        </Grid>
        <hr className={classes.separator} />
        <Grid container spacing={2}>
          <Grid item xs={6} className={classes.lightText}>
            <Typography variant="overline">Project</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="overline" className={classes.fontWeight500} data-mf-replace-inner={MFSDR}>
              {accountProject.project ? accountProject.project.name : `NO PROJECT`}
            </Typography>
          </Grid>
        </Grid>
        {purchaseOrder.selectedPurchaseOrder && (
          <React.Fragment>
            <hr className={classes.separator} />
            <Grid container spacing={2}>
              <Grid item xs={6} className={classes.lightText}>
                <Typography variant="overline">Purchase Order #</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="overline" className={classes.fontWeight500}>
                  {purchaseOrder.selectedPurchaseOrder}
                </Typography>
              </Grid>
            </Grid>
          </React.Fragment>
        )}
        <hr className={classes.separator} />
        <Grid container spacing={2}>
          <Grid item xs={6} className={classes.lightText}>
            <Typography variant="overline">Date</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="overline" className={classes.fontWeight500}>
              {moment(dateTime.selectedDateTime).format(`dddd D MMMM`)}
            </Typography>
          </Grid>
        </Grid>
        <hr className={classes.separator} />
        <Grid container spacing={2}>
          <Grid item xs={6} className={classes.lightText}>
            <Typography variant="overline">Start Time</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="overline" className={classes.fontWeight500}>
              {moment(dateTime.selectedDateTime).format(`h:mma`)}
            </Typography>
          </Grid>
        </Grid>
        <hr className={classes.separator} />
        <Grid container spacing={2}>
          <Grid item xs={6} className={classes.lightText}>
            <Typography variant="overline">Delivery Address</Typography>
          </Grid>
          <Grid item xs={6} data-mf-replace-inner={MFSDR}>
            {streetLine && (
              <Typography variant="overline" className={classes.fontWeight500}>
                {streetLine}
              </Typography>
            )}
            {stateLine && (
              <Typography variant="overline" className={classes.fontWeight500}>
                {stateLine}
              </Typography>
            )}
          </Grid>
        </Grid>
        {driverInstructions.selectedDriverInstructions && (
          <React.Fragment>
            <hr className={classes.separator} />
            <Grid container spacing={2}>
              <Grid item xs={6} className={classes.lightText}>
                <Typography variant="overline">Special Instructions</Typography>
              </Grid>
              <Grid item xs={6} data-mf-replace-inner={MFSDR}>
                <pre className={classes.themeOverline}>
                  <Typography variant="overline" className={cn(classes.fontWeight500, classes.textTransformNone)}>
                    {driverInstructions.selectedDriverInstructions}
                  </Typography>
                </pre>
              </Grid>
            </Grid>
          </React.Fragment>
        )}
        {lotNumber.selectedLotNumber && (
          <React.Fragment>
            <hr className={classes.separator} />
            <Grid container spacing={2}>
              <Grid item xs={6} className={classes.lightText}>
                <Typography variant="overline">Lot Number</Typography>
              </Grid>
              <Grid item xs={6}>
                <pre className={classes.themeOverline}>
                  <Typography variant="overline" className={cn(classes.fontWeight500, classes.textTransformNone)}>
                    {lotNumber.selectedLotNumber}
                  </Typography>
                </pre>
              </Grid>
            </Grid>
          </React.Fragment>
        )}
        <hr className={classes.separator} />
        <Grid container spacing={2}>
          <Grid item xs={6} className={classes.lightText}>
            <Typography variant="overline">Max Truck Size</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="overline" className={classes.fontWeight500}>
              {truckSize.selectedTruckSize === `any` || !truckSize.selectedTruckSize ? `Any Truck Size` : truckSize.selectedTruckSizeName}
            </Typography>
          </Grid>
        </Grid>
        {siteContact.selectedName && (
          <React.Fragment>
            <hr className={classes.separator} />
            <Grid container spacing={2}>
              <Grid item xs={6} className={classes.lightText}>
                <Typography variant="overline">Site Contact Name</Typography>
              </Grid>
              <Grid item xs={6} data-mf-replace-inner={MFSDR}>
                <Typography variant="overline" className={classes.fontWeight500}>
                  {siteContact.selectedName}
                </Typography>
              </Grid>
            </Grid>
          </React.Fragment>
        )}
        {siteContact.selectedPhoneNumber && (
          <React.Fragment>
            <hr className={classes.separator} />
            <Grid container spacing={2}>
              <Grid item xs={6} className={classes.lightText}>
                <Typography variant="overline">Site Contact Phone Number</Typography>
              </Grid>
              <Grid item xs={6} data-mf-replace-inner={MFSDR}>
                <Typography variant="overline" className={classes.fontWeight500}>
                  {siteContact.selectedPhoneNumber}
                </Typography>
              </Grid>
            </Grid>
          </React.Fragment>
        )}
        <hr className={classes.separator} />
        <Grid container spacing={2}>
          <Grid item xs={6} className={classes.lightText}>
            <Typography variant="overline">Product Description</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="overline" className={classes.fontWeight500}>
              {product.selectedProduct.description}
            </Typography>
          </Grid>
        </Grid>
        <hr className={classes.separator} />
        <Grid container spacing={2}>
          <Grid item xs={6} className={classes.lightText}>
            <Typography variant="overline">Product Code</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="overline" className={classes.fontWeight500}>
              {product.selectedProduct.code}
            </Typography>
          </Grid>
        </Grid>
        <hr className={classes.separator} />
        <Grid container spacing={2}>
          <Grid item xs={6} className={classes.lightText}>
            <Typography variant="overline">Quantity</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="overline" className={classes.fontWeight500}>
              {quantity.quantity} <span className={classes.textTransformLowercase}>m</span>
              <sup>3</sup>
            </Typography>
          </Grid>
        </Grid>
        <hr className={classes.separator} />
        <Grid container spacing={2}>
          <Grid item xs={6} className={classes.lightText}>
            <Typography variant="overline">Slump</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="overline" className={classes.fontWeight500}>
              {slump.slump}
            </Typography>
          </Grid>
        </Grid>
        <hr className={classes.separator} />
        <Grid container spacing={2}>
          <Grid item xs={6} className={classes.lightText}>
            <Typography variant="overline">Plus Load</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="overline" className={classes.fontWeight500}>
              {plusLoad.selectedPlusLoad ? `YES` : `NO`}
            </Typography>
          </Grid>
        </Grid>
        {(!testResults.selectedRequirements || testResults.selectedRequirements.value === `NO_TESTING_REQUIRED`) && (
          <React.Fragment>
            <hr className={classes.separator} />
            <Grid container spacing={2}>
              <Grid item xs={6} className={classes.lightText}>
                <Typography variant="overline">Test Requirements</Typography>
              </Grid>
              <Grid item xs={6}>
                <Grid container className={classes.flexWrapNowrap} alignItems="center">
                  <Grid item>
                    <Grid container>
                      <Grid item xs={12}>
                        <Typography variant="overline" className={classes.fontWeight500}>
                          No testing required
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </React.Fragment>
        )}
        {testResults.selectedRequirements && testResults.selectedRequirements.value !== `NO_TESTING_REQUIRED` && (
          <React.Fragment>
            <hr className={classes.separator} />
            <Grid container spacing={2}>
              <Grid item xs={6} className={classes.lightText}>
                <Typography variant="overline">Test Requirements</Typography>
              </Grid>
              <Grid item xs={6}>
                <Grid container className={classes.flexWrapNowrap} alignItems="center">
                  <Grid item>
                    <Grid container>
                      <Grid item xs={12}>
                        <Typography variant="overline" className={classes.fontWeight500}>
                          {testResults.selectedRequirements.description}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </React.Fragment>
        )}
        {testResults.selectedFrequency && testResults.selectedFrequency.value && testResults.selectedRequirements.value !== `NO_TESTING_REQUIRED` && (
          <React.Fragment>
            <hr className={classes.separator} />
            <Grid container spacing={2}>
              <Grid item xs={6} className={classes.lightText}>
                <Typography variant="overline">Test Frequency</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="overline" className={classes.fontWeight500}>
                  {testResults.selectedFrequency.description}
                </Typography>
              </Grid>
            </Grid>
          </React.Fragment>
        )}
        {testResults.selectedNotes && testResults.selectedRequirements.value !== `NO_TESTING_REQUIRED` && (
          <React.Fragment>
            <hr className={classes.separator} />
            <Grid container spacing={2}>
              <Grid item xs={6} className={classes.lightText}>
                <Typography variant="overline">Test Notes</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="overline" className={classes.fontWeight500}>
                  {testResults.selectedNotes}
                </Typography>
              </Grid>
            </Grid>
          </React.Fragment>
        )}
        <hr className={classes.separator} />
        <Grid container spacing={2}>
          <Grid item xs={6} className={classes.lightText}>
            <Typography variant="overline">Pour Method</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="overline" className={classes.fontWeight500}>
              {pourMethod.selectedPourMethod.name}
            </Typography>
          </Grid>
        </Grid>
        <hr className={classes.separator} />
        <Grid container spacing={2}>
          <Grid item xs={6} className={classes.lightText}>
            <Typography variant="overline">Truck Spacing</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="overline" className={classes.fontWeight500}>
              {truckSpacing.selectedTruckSpacing} minutes
            </Typography>
          </Grid>
        </Grid>
        <hr className={classes.separator} />
        <Grid container spacing={2}>
          <Grid item xs={6} className={classes.lightText}>
            <Typography variant="overline">Order Status</Typography>
          </Grid>
          <Grid item xs={6}>
            {orderStatus.confirmed ? (
              <Chip className={classes.confirmedChip} label="Confirmed" />
            ) : (
              <Chip className={classes.toBeConfirmedChip} label="To Be Confirmed" />
            )}
          </Grid>
        </Grid>
        <hr className={classes.separator} />
        <Typography variant="body2" className={cn(classes.marginTop3unit, classes.marginBottom2unit)}>
          By placing your order through Boral Connects you agree to the{' '}
          <a
            onClick={reportOpenTCs}
            rel="noopener noreferrer"
            target="_blank"
            className={classes.hyperlink}
            href="https://www.boral.com.au/products/concrete/terms_quotation_supply"
          >
            Concrete Terms of Quotation &amp; Supply
          </a>
        </Typography>

        {!isSaving ? (
          <Grid container spacing={2} justify="flex-end">
            <Grid item>
              <Button variant="contained" onClick={cancelOrderModal}>
                Cancel or Change
              </Button>
            </Grid>
            <Grid item>
              <Button color="primary" variant="contained" onClick={placeOrderModal}>
                Place order
              </Button>
            </Grid>
          </Grid>
        ) : (
          <Grid container spacing={2} justify="flex-end">
            <Grid item xs={2}>
              <Spinner size={20} loaderStyles={classes.spinner} />
            </Grid>
          </Grid>
        )}
      </React.Fragment>
    );
  };
   /**
+   * Open email client
+   * @returns {void} void
+   * @memberof PlaceOrder
+   */
      const openEmailFeedback = () => {
      window.open("mailto:boralconnects@boral.com.au")
    }
  /**
   * Renders success modal content
   * @returns {Object} react component
   * @memberof PlaceOrder
   */
  const renderSuccess = () => {
    return (
      <React.Fragment>
        <Grid container spacing={2}>
          <Grid item xs={12} className={classes.textAlignCenter}>
            <CheckCircleOutlineIcon color="primary" className={classes.checkIcon} />
          </Grid>
        </Grid>
        <Grid container spacing={4}>
          <Grid item xs={12} className={cn(classes.textAlignCenter, classes.marginBottom2unit)}>
            <Typography variant="h6">Your order has been placed</Typography>
          </Grid>
        </Grid>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Grid item xs={12} className={classes.textAlignCenter}>
              <Typography variant="body2">
                Your reference number for this order is <span className={classes.fontWeight500}>{showSuccess.orderId}</span>.
              </Typography>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Grid item xs={12} className={classes.textAlignCenter}>
              <Typography variant="body2">You can check the status of your orders anytime on Boral Connects.</Typography>
            </Grid>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  };

  /**
   * Renders invalid items list
   * @returns {Object} react component
   * @memberof PlaceOrder
   */
  const getInvalidItems = () => {
    // left here for future use
    return (
      <ul className={classes.errorList}>
        {!accountProject.isValid && (
          <li>
            <Typography variant="body2" className={classes.errorListItem}>
              Account/Project
            </Typography>
          </li>
        )}
        {!purchaseOrder.isValid && (
          <li>
            <Typography variant="body2" className={classes.errorListItem}>
              Purchase Order Number
            </Typography>
          </li>
        )}
        {!dateTime.isValid && (
          <li>
            <Typography variant="body2" className={classes.errorListItem}>
              Delivery Date/Time
            </Typography>
          </li>
        )}
        {!location.isValid && (
          <li>
            <Typography variant="body2" className={classes.errorListItem}>
              Delivery Address
            </Typography>
          </li>
        )}
        {!driverInstructions.isValid && (
          <li>
            <Typography variant="body2" className={classes.errorListItem}>
              Driver Instructions
            </Typography>
          </li>
        )}
        {!lotNumber.isValid && (
          <li>
            <Typography variant="body2" className={classes.errorListItem}>
              Lot Number
            </Typography>
          </li>
        )}
        {!siteContact.isValid && (
          <li>
            <Typography variant="body2" className={classes.errorListItem}>
              Site Contact
            </Typography>
          </li>
        )}
        {!product.isValid && (
          <li>
            <Typography variant="body2" className={classes.errorListItem}>
              Product
            </Typography>
          </li>
        )}
        {!slump.isValid && (
          <li>
            <Typography variant="body2" className={classes.errorListItem}>
              Slump
            </Typography>
          </li>
        )}
        {!pourMethod.isValid && (
          <li>
            <Typography variant="body2" className={classes.errorListItem}>
              Pour Method
            </Typography>
          </li>
        )}
        {!truckSpacing.isValid && (
          <li>
            <Typography variant="body2" className={classes.errorListItem}>
              Truck Spacing
            </Typography>
          </li>
        )}
        {!quantity.isValid && (
          <li>
            <Typography variant="body2" className={classes.errorListItem}>
              Quantity
            </Typography>
          </li>
        )}
        {!testResults.isValid && (
          <li>
            <Typography variant="body2" className={classes.errorListItem}>
              Testing Notes
            </Typography>
          </li>
        )}
        {!orderStatus.isValid && (
          <li>
            <Typography variant="body2" className={classes.errorListItem}>
              Order Status
            </Typography>
          </li>
        )}
      </ul>
    );
  };

  let isRequired = false;

  if (
    (accountProject && accountProject.project && accountProject.project.purchaseOrderRequired) ||
    (accountProject && accountProject.account && accountProject.account.purchaseOrderRequired)
  ) {
    isRequired = true;
  }

  return (
    <React.Fragment>
      <BannerNotificationComponent
        bannerClasses={classes.bannerTips}
        hidden={alreadyPlacedOnThisDevice}
        buttons={
          <Grid container spacing={2}>
            <Grid item className={cn(classes.flexGrow1, classes.textAlignRight)}>
              <Button color="primary" variant="contained" onClick={viewTipsBannerHandler}>
                Open page tips
              </Button>
            </Grid>
            <Grid item>
              <Button onClick={dismissBannerHandler}>Dismiss</Button>
            </Grid>
          </Grid>
        }
        icon={<Icons size="24" color="white" type="EMOJI_OBJECTS" className={classes.bannerTipsIcon} />}
        content={<Typography variant="body2">First time ordering online? Read the page tips to learn more.</Typography>}
      />

      <Drawer variant="persistent" open={drawerOpen} anchor="right" onClose={hideTips} classes={{ paper: classes.drawerPaper }}>
        <Grid container spacing={1} className={classes.drawer} alignItems="center">
          <Grid item>
            <Icons size="24" color={themeConstants.BORAL_GREEN} type="EMOJI_OBJECTS" />
          </Grid>
          <Grid item className={classes.flexGrow1}>
            <Typography className={classes.pageTipsTitle} variant="subtitle2">
              Page Tips
            </Typography>
          </Grid>
          <Grid item>
            <IconButton aria-label="Close tips" classes={{ root: classes.drawerClose }} color="inherit" key="closeDrawer" onClick={hideTips}>
              <CloseIcon size="24" />
            </IconButton>
          </Grid>
        </Grid>
        <div className={classes.separatorTips}>&nbsp;</div>
        <Grid container spacing={2} className={classes.drawerContent}>
          <Grid item xs={12}>
            <Typography variant="subtitle2" color="primary">
              Before you start
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2">
              Boral Connects has conditions for ordering online, as outlined below. Orders that can&apos;t be placed online can still be
              placed by{' '}
              <a rel="noopener noreferrer" target="_blank" href="https://www.boral.com.au/locations?product_category%5B86%5D=86" className={classes.callBoral}>
                calling Boral
              </a>
              .
            </Typography>
          </Grid>

        </Grid>
        <div className={classes.separatorTips}>&nbsp;</div>
        <Grid container spacing={2} className={classes.drawerContent}>
          <Grid item xs={12}>
            <Typography variant="subtitle2">Account</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2">
              <ul className={classes.tipsList}>
                <li>
                  <div className={classes.fakeBulletPoint}>»</div>Active account with no credit issues
                </li>
                <li>
                  <div className={classes.fakeBulletPoint}>»</div>Within national serviceable regions
                </li>
              </ul>
            </Typography>
          </Grid>
        </Grid>
        <div className={classes.separatorTips}>&nbsp;</div>
        <Grid container spacing={2} className={classes.drawerContent}>
          <Grid item xs={12}>
            <Typography variant="subtitle2">Project</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2">
              <ul className={classes.tipsList}>
                <li>
                  <div className={classes.fakeBulletPoint}>»</div>As required by your account
                </li>
              </ul>
            </Typography>
          </Grid>
        </Grid>
        <div className={classes.separatorTips}>&nbsp;</div>
        <Grid container spacing={2} className={classes.drawerContent}>
          <Grid item xs={12}>
            <Typography variant="subtitle2">PO Number</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2">
              <ul className={classes.tipsList}>
                <li>
                  <div className={classes.fakeBulletPoint}>»</div>As required by your account or project
                </li>
              </ul>
            </Typography>
          </Grid>
        </Grid>
        <div className={classes.separatorTips}>&nbsp;</div>
        <Grid container spacing={2} className={classes.drawerContent}>
          <Grid item xs={12}>
            <Typography variant="subtitle2">Delivery Address</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2">
              <ul className={classes.tipsList}>
                <li>
                  <div className={classes.fakeBulletPoint}>»</div>Include street name and number
                </li>
                <li>
                  <div className={classes.fakeBulletPoint}>»</div>Within national serviceable regions
                </li>
              </ul>
            </Typography>
          </Grid>
        </Grid>
        <div className={classes.separatorTips}>&nbsp;</div>
        <Grid container spacing={2} className={classes.drawerContent}>
          <Grid item xs={12}>
            <Typography variant="subtitle2">{`Delivery Date & Time`}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2">
              <ul className={classes.tipsList}>
                <li>
                  <div className={classes.fakeBulletPoint}>»</div>
                  Next Day: Please{' '}
                  <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href="https://www.boral.com.au/locations?product_category%5B86%5D=86"
                    className={classes.callBoral}
                  >
                    <a
                      rel="noopener noreferrer"
                      target="_blank"
                      href="https://www.boral.com.au/locations?product_category%5B86%5D=86"
                      className={classes.callBoral}
                    >
                      Call Boral
                    </a>
                  </a>
                </li>
                <li>
                  <div className={classes.fakeBulletPoint}>»</div>
                  {`In 2 - 3 business days: 12PM - 4PM`}
                </li>
                <li>
                  <div className={classes.fakeBulletPoint}>»</div>
                  {`In 4 - 30 business days: 6AM - 4PM`}
                </li>
                <li>
                  <div className={classes.fakeBulletPoint}>»</div>
                  {`Sat: 6AM - 12PM`}
                </li>
                <li>
                  <div className={classes.fakeBulletPoint}>»</div>
                  {`Sun & public holidays: Not available`}
                </li>
                <li>
                  <div className={classes.fakeBulletPoint}>»</div>
                  {`Online orders will be unavailable during our End of Year period, from 20th December to 6th January.`}
                </li>
              </ul>
            </Typography>
          </Grid>
        </Grid>
        <div className={classes.separatorTips}>&nbsp;</div>
        <Grid container spacing={2} className={classes.drawerContent}>
          <Grid item xs={12}>
            <Typography variant="subtitle2">Product</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2">
              <ul className={classes.tipsList}>
                <li>
                  <div className={classes.fakeBulletPoint}>»</div>Please{' '}
                  <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href="https://www.boral.com.au/locations?product_category%5B86%5D=86"
                    className={classes.callBoral}
                  >
                    Call Boral
                  </a>{' '}
                  for products not available online including oxides or additives
                </li>
              </ul>
            </Typography>
          </Grid>
        </Grid>
        <div className={classes.separatorTips}>&nbsp;</div>
        <Grid container spacing={2} className={classes.drawerContent}>
          <Grid item xs={12}>
            <Typography variant="subtitle2">Load Size &amp; Spacing</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2">
              <ul className={classes.tipsList}>
                <li>
                  <div className={classes.fakeBulletPoint}>»</div>Please{' '}
                  <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href="https://www.boral.com.au/locations?product_category%5B86%5D=86"
                    className={classes.callBoral}
                  >
                    Call Boral
                  </a>
                </li>
                <li>
                  <div className={classes.fakeBulletPoint}>»</div>Recommended spacing is based on pour method{' '}
                </li>
              </ul>
            </Typography>
          </Grid>
        </Grid>
        <div className={classes.separatorTips}>&nbsp;</div>
        <Grid container spacing={2} className={classes.drawerContent}>
          <Grid item xs={12}>
            <Typography variant="subtitle2">Quantity</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2">
              <ul className={classes.tipsList}>
                <li>
                  <div className={classes.fakeBulletPoint}>»</div>Min 0.4m3 / Max 2000m3
                </li>
              </ul>
            </Typography>
          </Grid>
        </Grid>
        <div className={classes.separatorTips}>&nbsp;</div>
        <Grid container spacing={2} className={classes.drawerContent}>
          <Grid item xs={12}>
            <Typography variant="subtitle2">Testing</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2">
              <ul className={classes.tipsList}>
                <li>
                  <div className={classes.fakeBulletPoint}>»</div>Please{' '}
                  <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href="https://www.boral.com.au/locations?product_category%5B86%5D=86"
                    className={classes.callBoral}
                  >
                    Call Boral
                  </a>{' '}
                  for multiple testing requirements
                </li>
              </ul>
            </Typography>
          </Grid>
        </Grid>
        <div className={classes.separatorTips}>&nbsp;</div>
        <Grid container spacing={2} className={classes.drawerContent}>
          <Grid item xs={12}>
            <Typography variant="subtitle2">Plus Loads</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2">
              <ul className={classes.tipsList}>
                <li>
                  <div className={classes.fakeBulletPoint}>»</div>Please{' '}
                  <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href="https://www.boral.com.au/locations?product_category%5B86%5D=86"
                    className={classes.callBoral}
                  >
                    Call Boral
                  </a>{' '}
                  to specify a plus load
                </li>
              </ul>
            </Typography>
          </Grid>
        </Grid>
        <div className={classes.separatorTips}>&nbsp;</div>
        <Grid container spacing={2} className={cn(classes.feedback, classes.drawerContent)}>
          <Grid item xs={12}>
            <Typography variant="body2">
              <span
                className={classes.feedbackLink}
                onClick={() => {
                  openEmailFeedback();
                  hideTips();
                }}
              >
                Your feedback
              </span>{' '}
              is very valuable to us and will help us improve online ordering.
            </Typography>
          </Grid>
        </Grid>
      </Drawer>
      <Snackbar
        action={[
          <IconButton aria-label="Close" className={classes.close} color="inherit" key="close" onClick={() => setPlaceOrderError(false)}>
            <CloseIcon />
          </IconButton>,
        ]}
        anchorOrigin={{
          horizontal: `left`,
          vertical: `bottom`,
        }}
        className={classes.snackbar}
        ContentProps={{ classes: { root: classes.error } }}
        message={
          <span className={classes.snackbarMessage} id="client-snackbar">
            <ErrorIcon className={classes.snackbarIcon} />
            An error has occurred. Please try again later.
          </span>
        }
        open={placeOrderError}
      />
      <Modal
        preventFullScreen
        content={<Typography variant="body2">Are you sure you want to leave this page?</Typography>}
        onClose={() => {}}
        open={!!showConfirm}
        paperClasses={classes.paperClasses}
        footer={
          <Grid container spacing={2} justify="flex-end">
            <Grid item>
              <Button variant="contained" color="primary" onClick={navigateAway}>
                Yes
              </Button>
            </Grid>
            <Grid item>
              <Button variant="contained" onClick={ignoreNavigation}>
                No
              </Button>
            </Grid>
          </Grid>
        }
      />
      <Modal
        content={renderReview()}
        open={!!showReview}
        hideCloseIcon
        title={
          <Grid container className={classes.marginBottom2unit}>
            <Grid item xs={12}>
              Review Your Order
            </Grid>
          </Grid>
        }
        paperClasses={classes.paperClassesReview}
      />
      <Button className={classes.pageTips} size="small" color="primary" onClick={showTips}>
        <Icons size="18" color={themeConstants.BORAL_GREEN} type="EMOJI_OBJECTS" className={cn(classes.pageTipsIcon)} />
        <span className={classes.textTransformCapitalize}>Page Tips</span>
      </Button>
      <div className={classes.pageTipsMobile} onClick={showTips}>
        <Icons size="18" color={themeConstants.BORAL_GREEN} type="EMOJI_OBJECTS" className={cn(classes.pageTipsIcon)} />
      </div>
      <Modal
        content={renderSuccess()}
        open={!!showSuccess}
        hideCloseIcon
        paperClasses={classes.paperClassesSuccess}
        footer={
          <Grid container spacing={2} justify="flex-end">
            <Grid item>
              <Button variant="contained" onClick={placeAnotherOrder}>
                Place another order
              </Button>
            </Grid>
            <Grid item>
              <Button variant="contained" onClick={goToThisOrdersList}>
                Go to this order
              </Button>
            </Grid>
            <Grid item>
              <Button color="primary" variant="contained" onClick={goToOrdersList}>
                Go to all orders
              </Button>
            </Grid>
          </Grid>
        }
      />
      <Grid container spacing={2} key={formRefreshKey} className={!alreadyPlacedOnThisDevice && classes.underBannerTipsPadding}>
        <Grid item xs={12}>
          <Typography variant="body2">All fields are mandatory unless specified otherwise</Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h6" className={classes.heading}>
            Account &amp; Project
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          {renderAccountProjectSelector()}
        </Grid>

        {accountProject.isValid && (
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} className={classes.marginBottom3unit}>
                <PurchaseOrderSelector
                  isRequired={isRequired}
                  defaultPurchaseOrder={purchaseOrder}
                  onChange={purchaseOrderHandler}
                />
              </Grid>
            </Grid>
          </Grid>
        )}
        {accountProject.isValid && (
          <React.Fragment>
            <Grid item xs={12}>
              <Typography variant="h6" className={classes.heading}>
                Delivery Date &amp; Time
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} className={classes.marginBottom3unit}>
              {renderDateTimeSelector()}
            </Grid>
          </React.Fragment>
        )}
        {accountProject.isValid && dateTime.isValid && (
          <React.Fragment>
            <Grid item xs={12}>
              <Typography variant="h6" className={classes.heading}>
                Site Information
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Grid container spacing={2}>
                <Grid item xs={12} className={classes.marginBottom3unit}>
                  <div data-mf-replace-inner={MFSDR}>
                    <HereMaps
                      isDriverInstructionsRequired={isDriverInstructionsRequired}
                      mandatoryFieldError={showFormErrors && !location.isValid}
                      defaultLocation={location ? location.selectedLocation : null}
                      onLocationChange={locationHandler}
                      onAddressStreetNumberChange={addressStreetNumberChangeHandler}
                    />
                  </div>
                </Grid>
                <Grid item xs={12} className={classes.marginBottom1unit} data-mf-replace-inner={MFSDR}>
                  <DriverInstructions
                    mandatoryFieldError={showFormErrors && !driverInstructions.isValid}
                    driverInstructionsContent={driverInstructions.selectedDriverInstructions || null}
                    onChange={driverInstructionsHandler}
                    isRequired={isDriverInstructionsRequired}
                  />
                </Grid>
                <Grid item xs={12} className={classes.marginBottom1unit}>
                  <LotNumberSelector
                    mandatoryFieldError={showFormErrors && !lotNumber.isValid}
                    isRequired={isRequired}
                    defaultLotNumber={lotNumber}
                    onChange={lotNumberHandler}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TruckSizeSelector defaultTruckSize={truckSize.selectedTruckSize} onChange={truckSizeHandler} stateCode={stateCode} />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} className={classes.marginBottom3unit}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} className={classes.marginBottom3unit} data-mf-replace-inner={MFSDR}>
                  <SiteContact
                    mandatoryFieldError={showFormErrors && !siteContact.isValid}
                    onChange={siteContactHandler}
                    defaultName={siteContact.selectedName}
                    defaultPhoneNumber={siteContact.selectedPhoneNumber}
                  />
                </Grid>
              </Grid>
            </Grid>
          </React.Fragment>
        )}
        {accountProject.isValid && dateTime.isValid && location.isValid && driverInstructions.isValid && (
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h6" className={classes.heading}>
                  Concrete Settings
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <ProductSelector
                  mandatoryFieldError={showFormErrors && !product.isValid}
                  defaultProduct={product}
                  onChange={productHandler}
                  locationCode={accountProject.account.id}
                  coordinates={location.selectedLocation.coords}
                  projectId={accountProject.project ? accountProject.project.id : null}
                />
              </Grid>
            </Grid>
          </Grid>
        )}

        {product.isValid && accountProject.isValid && dateTime.isValid && location.isValid && driverInstructions.isValid && (
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Grid container spacing={2} className={classes.marginBottom3unit}>
                  {/* need to refresh it every time to make it behave when product is updated and when form is hidden via earlier fields. ATM not sure how to sort it out without key */}
                  <Grid key={Date.now()} item xs={12} sm={6}>
                    <SlumpSelector
                      mandatoryFieldError={showFormErrors && !slump.isValid}
                      noSlump={slump.slump === null}
                      enteredSlump={slump.slump}
                      product={product}
                      onChange={slumpHandler}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={6}>
                  {' '}
                  <PourMethod mandatoryFieldError={showFormErrors && !pourMethod.isValid} defaultPourMethod={pourMethod} onChange={pourMethodHandler} />{' '}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        )}

        {product.isValid && accountProject.isValid && dateTime.isValid && location.isValid && driverInstructions.isValid && pourMethod.isValid && (
          <Grid item xs={12}>
            <Grid container spacing={2}>
              {` `}
              <Grid item xs={12} sm={6}>
                <TruckSpacingSelector
                  mandatoryFieldError={showFormErrors && !truckSpacing.isValid}
                  defaultTruckSpacing={truckSpacing}
                  pourMethod={pourMethod.selectedPourMethod}
                  onChange={truckSpacingHandler}
                />
              </Grid>
            </Grid>
          </Grid>
        )}

        {product.isValid && accountProject.isValid && dateTime.isValid && location.isValid && driverInstructions.isValid && pourMethod.isValid && pourMethod.isValid && (
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <QuantitySelector
                      mandatoryFieldError={showFormErrors && !quantity.isValid}
                      defaultQuantity={quantity.quantity ? quantity.quantity * 1 : null}
                      onChange={quantitytHandler}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} className={classes.marginBottom1unit}>
                    <PlusLoad isOn={plusLoad.selectedPlusLoad} onChange={plusLoadHandler} />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} className={classes.marginBottom3unit}>
                    <TestResults
                      mandatoryFieldError={showFormErrors && !testResults.isValid}
                      defaultNotes={testResults.selectedNotes}
                      defaultRequirements={testResults.selectedRequirements && testResults.selectedRequirements.value}
                      defaultFrequency={testResults.selectedFrequency && testResults.selectedFrequency.value}
                      onChange={testResultsHandler}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        )}

        {product.isValid && accountProject.isValid && dateTime.isValid && location.isValid && driverInstructions.isValid && pourMethod.isValid && quantity.isValid && pourMethod.isValid && (
          <React.Fragment>
            <Grid item xs={12}>
              <Typography variant="h6" className={classes.heading}>
                Order Status
              </Typography>
            </Grid>
            <Grid item xs={12} md={6} className={classes.marginBottom3unit}>
              <OrderStatusSelector
                mandatoryFieldError={showFormErrors && !orderStatus.isValid}
                defaultStatus={orderStatus.confirmed}
                onChange={statusOrderHandler}
              />
            </Grid>
          </React.Fragment>
        )}

        <Grid item xs={12} className={classes.placeOrderButtons}>
          {' '}
          {showFormErrors && !isAllValid() && (
            <Grid container>
              <Grid item xs={12} sm={6} className={classes.marginBottom3unit}>
                <PlaceOrderErrorMessage
                  message={
                    <React.Fragment>
                      <Typography variant="body2" className={classes.errorText}>
                        There are items that require your attention. You must complete these before continuing.
                      </Typography>
                    </React.Fragment>
                  }
                />
              </Grid>
            </Grid>
          )}
          <Button onClick={createOrderHandler} variant="contained" color="primary">
            Finish &amp; Review
          </Button>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

PlaceOrder.propTypes = PlaceOrderPropTypes;

export default compose(
  withWidth(),
  withRouter,
  withServices,
  connect(
    (state) => ({
      listSettings: state.dockets ? state.dockets.listSettings : null,
      userInfo: userProfileSelector(state),
      currentAccountGlobal: getFiltersSelectedAccount(state),
    }),
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...uiActionCreators,
          ...filtersActionCreators,
          ...docketsActionCreators,
        },
        dispatch,
      ),
    }),
  ),
  withStyles(themeCreateInjectableStyles(placeOrderStyles), { withTheme: true }),
)(PlaceOrder);
